import { render, staticRenderFns } from "./PersonCodeValue.vue?vue&type=template&id=4d2d017c"
import script from "./PersonCodeValue.vue?vue&type=script&lang=js"
export * from "./PersonCodeValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports